
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_4c84z_1bhlj_5",
  "variant-secondary": "awsui_variant-secondary_4c84z_1bhlj_47",
  "variant-primary": "awsui_variant-primary_4c84z_1bhlj_80",
  "variant-info": "awsui_variant-info_4c84z_1bhlj_113",
  "variant-top-navigation": "awsui_variant-top-navigation_4c84z_1bhlj_146",
  "variant-recovery": "awsui_variant-recovery_4c84z_1bhlj_179",
  "button": "awsui_button_4c84z_1bhlj_212",
  "color-inverted": "awsui_color-inverted_4c84z_1bhlj_245",
  "font-size-body-s": "awsui_font-size-body-s_4c84z_1bhlj_263",
  "font-size-body-m": "awsui_font-size-body-m_4c84z_1bhlj_268",
  "font-size-heading-xs": "awsui_font-size-heading-xs_4c84z_1bhlj_272",
  "font-size-heading-s": "awsui_font-size-heading-s_4c84z_1bhlj_276",
  "font-size-heading-m": "awsui_font-size-heading-m_4c84z_1bhlj_281",
  "font-size-heading-l": "awsui_font-size-heading-l_4c84z_1bhlj_286",
  "font-size-heading-xl": "awsui_font-size-heading-xl_4c84z_1bhlj_291",
  "font-size-display-l": "awsui_font-size-display-l_4c84z_1bhlj_296",
  "icon": "awsui_icon_4c84z_1bhlj_302"
};
  